<div
  class="header-search position-relative {{ andClass }}"
  [class.search-box]="searchBoxStyle === 'round'"
  [class.loading]="loadingQuick && loading"
  nkClickOutside
  (clickOutside)="onClickOutside()">
  <input
    class="form-control company-person-search-input {{ andInputClass }}"
    [attr.data-cy]="'company-person-search-input'"
    [disabled]="disabled"
    [(ngModel)]="simpleSearchInput"
    (ngModelChange)="onInputChange($event)"
    (click)="openDropdown = true"
    (focus)="openDropdown = true"
    [class.active]="openDropdown"
    (keydown)="onKeyDown($event)"
    [placeholder]="placeholder" />

  @if (!dontShowResults) {
    <nk-company-person-search-results
      [disableEnterKey]="loadingQuick"
      [selectedItemIndex]="selectedItemIndex"
      [openDropdown]="openDropdown"
      [aggregatedSimpleSearchResults]="aggregatedSearchResults"
      (searchSelect)="onSearchSelect($event)"
      [query]="simpleSearchInput">
    </nk-company-person-search-results>
  }
</div>
